import { useAuthStore } from '@/auth/authStore';
import { SERVER_URL, COMMON_HEADERS } from '@/config/serverUrl';

const BASE = SERVER_URL;

export type TrialKind = 'character' | 'holdSkin' | 'finisher' | 'background';
export interface TrialEntry {
  kind: TrialKind;
  itemId: string;
  usesLeft: number;
}

async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = useAuthStore.getState().token;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...COMMON_HEADERS,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body == null ? undefined : JSON.stringify(body),
    credentials: 'include',
  });
  if (!res.ok) {
    let code = `HTTP_${res.status}`;
    try { const j = await res.json(); code = j?.error ?? code; } catch { /* */ }
    throw new Error(code);
  }
  return (await res.json()) as T;
}

export const trialApi = {
  list: () => req<{ active: TrialEntry[]; trials: TrialEntry[] }>('GET', '/shop/trial'),
  start: (kind: TrialKind, itemId: string) =>
    req<{ ok: true; kind: TrialKind; itemId: string; usesLeft: number }>(
      'POST', '/shop/trial', { kind, itemId },
    ),
  /** Decrement active trials by one match; reverts expired ones server-side. */
  consume: () => req<{ active: TrialEntry[]; reverted: Array<{ kind: TrialKind; equippedId: string | null }> }>(
    'POST', '/shop/trial/consume',
  ),
};
